<script setup>
import { h, isVNode } from 'vue';

const props = defineProps({
  icon: { type: [String, Object, Function], required: true },
});

const isImagePath = str => {
  if (str.startsWith('http://') || str.startsWith('https://')) {
    return true;
  }

  const imageExtensions = [
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.svg',
    '.webp',
    '.bmp',
    '.ico',
  ];
  return imageExtensions.some(ext => str.toLowerCase().includes(ext));
};

const renderIcon = () => {
  if (!props.icon) return null;
  if (typeof props.icon === 'function' || isVNode(props.icon)) {
    return props.icon;
  }
  if (typeof props.icon === 'string' && isImagePath(props.icon)) {
    return h('img', {
      src: props.icon,
      alt: 'icon',
      class: 'icon-image',
      style: { width: '16px', height: '16px', objectFit: 'contain' },
    });
  }
  return h('span', { class: props.icon });
};
</script>

<template>
  <component :is="renderIcon" />
</template>
